import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../../config/config';

@Injectable({
  providedIn: 'root'
})
export class IvaPagClieService {

  dataUrl = Config.URL_BASE + '/rep-fis';
  constructor(private http: HttpClient) { }


  getRepIvaPag(_gral_emp_id: number,ctb_tpol_grupo_id: number,ctb_cta_id: number,fecha_inicial: String,fecha_final: String): Observable<any> {
    let url_ = this.dataUrl + '/iva_pag_clie/'+_gral_emp_id+'/'+ctb_tpol_grupo_id+'/'+ctb_cta_id+'/'+fecha_inicial+'/'+fecha_final;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  ctb_erp_rep_iva_pagado_clie_pa(_gral_emp_id: number,ctb_cta_id: number,fecha_inicial: String,fecha_final: String): Observable<any> {
    let url_ = this.dataUrl + '/ctb_erp_rep_iva_pagado_clie_pa/'+_gral_emp_id+'/'+ctb_cta_id+'/'+fecha_inicial+'/'+fecha_final;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  tpolGetGrupo(): Observable<any> {
    let url_ = Config.URL_BASE + '/tpol/get/grupo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  
  ctaCatalogo(criterio: any): Observable<any> {
    let url_ = Config.URL_BASE +  '/cta/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
export class PageBusquedaObject {
  column?: string | undefined = '';
  criteriaSearch?: any | undefined = {};
  itemsPerPage?: number | undefined = 10;
  order?: string | undefined = '';
  pageNumber?: number = 1;
  sort?: boolean | undefined = false;
  page1?: boolean | undefined = false;
}